<mat-card appearance="outlined" class="card pointer-default">
  <mat-card-title>{{headerText}}</mat-card-title>  
  <mat-card-content>
    <div *ngIf="isLoading"  class="center-container">
      <mat-spinner [diameter]="60" ></mat-spinner>
    </div>

    <div *ngIf="!isLoading && showLast"  class="t1 status-item-text">Compared to last year</div>
    <div *ngIf="!isLoading && showLast" class="t2 bold status-item-text">{{countsLast}}% counts</div>
    <div *ngIf="!isLoading" class="t9 bold status-item-text-current">{{countsCurrent}}</div>
    <div *ngIf="!isLoading && showLast" class="t1 bold status-item-text">{{footer}}</div>
  </mat-card-content>  
  </mat-card>